/*
  webpackChunkName不要使用以app结尾
  在打包的时候会去检测包含'index.'的文件设置当前打包次数
  免得打包出问题
*/

const Main = () => import(/* webpackChunkName: "main" */ '@/views/main/main')
const ShopList = () => import(/* webpackChunkName: "shopList" */ '@/views/shop-list/shop-list')
const ShopRegister = () => import(/* webpackChunkName: "shopRegister" */ '@/views/shop-register/shop-register')
const miniMarketRegister = () => import(/* webpackChunkName: "miniMarketRegister" */ '@/views/minimarket-register/minimarket-register')
const chainMatchingRegister = () => import(/* webpackChunkName: "chainMatchingRegister" */ '@/views/chainMatching-register/chainMatching-register')
const retailSalesRegister = () => import(/* webpackChunkName: "retailSalesRegister" */ '@/views/retailSales-register/retailSales-register')
const paymentApply = () => import(/* webpackChunkName: "paymentApply" */ '@/views/payment-apply/paymentApply') // 扫呗对应的申请渠道
const paymentSqbApply = () => import(/* webpackChunkName: "paymentApply" */ '@/views/payment-sqbapply/paymentSqbApply') // 收钱吧对应的申请渠道
const shopApply = () => import(/* webpackChunkName: "shopApply" */ '@/views/shop-apply/shopApply') // 扫呗对应的申请页面
// const shopSqbApply = () =>  import(/* webpackChunkName: "shopSqbApply" */ '@/views/shop-sqbapply/shopSqbApply')  // 收钱吧对应的申请页面
const paymentStatus = () => import(/* webpackChunkName: "paymentStatus" */ '@/views/payment-status/paymentStatus')
const shopApplyStatus = () => import(/* webpackChunkName: "shopApplyStatus" */ '@/views/shopApply-status/shopApplyStatus')
const paymentApprovedLoading = () => import(/* webpackChunkName: "payment" */ '@/views/payment-approved/loading')
const paymentApproved = () => import(/* webpackChunkName: "payment" */ '@/views/payment-approved/payment-approved')
const CashierList = () => import(/* webpackChunkName: "cashier" */ '@/views/cashier-list/cashier-list')
const GoToCashier = () => import(/* webpackChunkName: "cashier" */ '@/views/cashier-list/go-to-cashier')
const paymentCenter = () => import(/* webpackChunkName: "paymentCenter" */ '@/views/payment-center/paymentCenter')
const recordViews = () => import(/* webpackChunkName: "recordViews" */ '@/views/payment-center/recordViews')
const dealerRegister = () => import(/* webpackChunkName: "dealerRegister" */ '@/views/dealer-register/dealerRegister')

export default {
  path: '/main',
  redirect: '/main/shopList',
  component: Main,
  children: [{
      path: 'cashierList',
      name: 'cashierList',
      component: CashierList,
      meta: {
        title: '收银台',
      }
    }, {
      path: 'goToCashier',
      name: 'goToCashier',
      component: GoToCashier
    },
    {
      path: 'shopList',
      name: 'shopList',
      component: ShopList,
      meta: {
        title: '选择店铺',
      }
    },
    {
      path: 'shopRegister',
      name: 'shopRegister',
      component: ShopRegister,
      meta: {
        title: '店铺注册',
      }
    },
    {
      path: 'miniMarketRegister',
      name: 'miniMarketRegister',
      component: miniMarketRegister,
      meta: {
        title: '微商城注册',
      }
    },
    {
      path: 'chainMatchingRegister',
      name: 'chainMatchingRegister',
      component: chainMatchingRegister,
      meta: {
        title: '连锁采配注册',
      }
    },
    {
      path: 'dealerRegister',
      name: 'dealerRegister',
      component: dealerRegister,
      meta: {
        title: '供货商注册',
      }
    },
    {
      path: 'retailSalesRegister',
      name: 'retailSalesRegister',
      component: retailSalesRegister,
      meta: {
        title: '门店零售注册',
      }
    },
    {
      path: 'paymentApply',
      name: 'paymentApply',
      component: paymentApply,
      meta: {
        title: '支付通道申请',
      }
    },
    {
      path: 'paymentSqbApply',
      name: 'paymentSqbApply',
      component: paymentSqbApply,
      meta: {
        title: '支付通道申请',
      }
    },
    // 支付通道申请表单详情页
    {
      path: 'paymentStatus',
      name: 'paymentStatus',
      component: paymentStatus,
      meta: {
        title: '支付通道申请',
      }
    },
    // 判断有无已通过的可直接使用的支付通道的加载页
    {
      path: 'paymentApprovedLoading',
      name: 'paymentApprovedLoading',
      component: paymentApprovedLoading,
      meta: {
        title: '加载中',
      }
    },
    // 已通过的支付申请的列表页
    {
      path: 'paymentApproved',
      name: 'paymentApproved',
      component: paymentApproved,
      meta: {
        title: '已开通支付通道',
      }
    },
    {
      path: 'shopApply',
      name: 'shopApply',
      component: shopApply,
      meta: {
        title: '店铺认证',
      }
    },
    // 店铺认证的表单详情页
    {
      path: 'shopApplyStatus',
      name: 'shopApplyStatus',
      component: shopApplyStatus,
      meta: {
        title: '店铺认证',
      }
    },
    // 支付中心
    {
      path: 'paymentCenter',
      name: 'paymentCenter',
      component: paymentCenter,
      meta: {
        title: '支付中心',
      }
    },
    // 支付记录
    {
      path: 'recordViews',
      name: 'recordViews',
      meta: {
        title: '付费中心',
      },
      component: recordViews,
    },
  ]}